import React, { useState, useEffect } from "react";
import ImageTag from "../../reusebale/imageTag";
import ParagraphTag from "../../reusebale/Paragraph";
import db from "../../../db/index.json";
import InfoCards from "../../reusebale/cards";
import { useSelector } from "react-redux";
import BaseUrl from "../../../constants/BaseUrl";
import { UserRound, Mail, Phone, CalendarPlus } from "lucide-react";
import moment from "moment";

const ProfileInfo = ({ onBack, onAction }) => {
  const { home } = db;
  const { loginSuccess } = useSelector((state) => state.auth);

  console.log("loginSuccess", loginSuccess);

  const [profileInfo, setProfileInfo] = useState();

  useEffect(() => {
    const GetProfileInformation = () => {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(
        `${BaseUrl}tenant/profile/getProfileDetails/${loginSuccess?.user?._id}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "Success") {
            setProfileInfo(result.data);
          }
        })
        .catch((error) => console.error(error));
    };

    if (loginSuccess?.user?._id && loginSuccess?.token) {
      GetProfileInformation();
    }
  }, [loginSuccess]);
  return (
    <div>
      <div className="mt-3 flex justify-between">
        <div className="w-[40%] bg-white rounded-xl">
          <div className="px-4 pt-7">
            <ParagraphTag
              content="Personal Information"
              classes="text-darkColor font-popinsSemiBold text-lg mt-[-3px]"
            />
          </div>
          <div className="mt-1 ml-4">
            <div className="flex w-full pt-7">
              <div className=" w-[50%] flex items-center">
                <div className="w-9 h-9 rounded-full flex justify-center items-center bg-bgColor">
                  <UserRound color="#FF814E" strokeWidth={2} size={20} />
                </div>
                <div className="pl-2">
                  <ParagraphTag
                    content="Name"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={`${profileInfo?.personalInformation?.firstName} ${profileInfo?.personalInformation?.lastName}`}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
              </div>
              <div className="w-[50%] flex items-center">
                <div className="w-9 h-9 rounded-full flex justify-center items-center bg-bgColor">
                  <Mail color="#FF814E" strokeWidth={2} size={20} />
                </div>
                <div className="pl-2">
                  <ParagraphTag
                    content="Email Address"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={`${profileInfo?.personalInformation?.email}`}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
              </div>
            </div>
            <div className="flex w-full pt-7">
              <div className="w-[50%] flex items-center">
                <div className="w-9 h-9 rounded-full flex justify-center items-center bg-bgColor">
                  <Phone color="#FF814E" strokeWidth={2} size={20} />
                </div>
                <div className="pl-2">
                  <ParagraphTag
                    content="Cell Number"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={`${profileInfo?.personalInformation?.phoneNumber}`}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
              </div>
              <div className="w-[50%] flex items-center">
                <div className="w-9 h-9 rounded-full flex justify-center items-center bg-bgColor">
                  <CalendarPlus color="#FF814E" strokeWidth={2} size={20} />
                </div>
                <div className="pl-2">
                  <ParagraphTag
                    content="Create at"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={moment(profileInfo?.createdAt).format(
                      "MM/DD/YYYY"
                    )}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-[59%] bg-white rounded-xl">
          <div className="px-4 pt-4">
            <ParagraphTag
              content="Company Information"
              classes="text-darkColor font-popinsSemiBold text-lg mt-[-3px]"
            />
          </div>
          <div className="flex mt-1 items-center">
            <div className="w-[30%]">
              <ImageTag
                path={`${profileInfo?.companyInformation?.companyLogo?.url}`}
                classes="w-[230px] rounded-full"
                altText="logo"
              />
            </div>
            <div className="w-[70%] px-2">
              <div className="pt-3">
                <ParagraphTag
                  content="Company Name"
                  classes="text-darkColor font-popinsSemiBold text-sm"
                />
                <ParagraphTag
                  content={`${profileInfo?.companyInformation?.companyName}`}
                  classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                />
              </div>

              <div className="pt-3">
                <ParagraphTag
                  content="Complete Address"
                  classes="text-darkColor font-popinsSemiBold text-sm"
                />
                <ParagraphTag
                  content={`${profileInfo?.companyInformation?.completeAddress}`}
                  classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                />
              </div>

              <div className="pt-2 flex">
                <div className="w-[50%]">
                  <ParagraphTag
                    content="Street One"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={`${profileInfo?.companyInformation?.street1}`}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
                <div className="w-[50%]">
                  <ParagraphTag
                    content="Street Two"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={`${profileInfo?.companyInformation?.street2}`}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
              </div>

              <div className="pt-2 flex">
                <div className="w-[50%]">
                  <ParagraphTag
                    content="City"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={`${profileInfo?.companyInformation?.city}`}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
                <div className="w-[50%]">
                  <ParagraphTag
                    content="State"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={`${profileInfo?.companyInformation?.state}`}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
              </div>

              <div className="pt-2 flex">
                <div className="w-[50%]">
                  <ParagraphTag
                    content="Country"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={`${profileInfo?.companyInformation?.country}`}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>

                <div className="w-[50%]">
                  <ParagraphTag
                    content="Zip Code"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={`${profileInfo?.companyInformation?.zipCode}`}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
              </div>
              <div className="pt-2 flex mb-4">
                <div className="w-[50%]">
                  <ParagraphTag
                    content="Website "
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={`${profileInfo?.companyInformation?.companyWebsite}`}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-wrap mt-5" id="gk-cards">
        {home.cardData2.map((item, i) => (
          <InfoCards key={i} item={item} onTrigger={onAction} />
        ))}
      </div>
    </div>
  );
};

export default ProfileInfo;
